.ux-form-step {
  display: block;
}
